import { Table, TableBody, TableContainer } from '@mui/material'
import { SelectorItem } from '../UserOrGroupSelector'
import SharedWithItemsRow from './SharedWithItemsRow'
import OwnerRow from '../OwnerRow'
import { Users } from 'features/account/types'

// Aux
function SharedWithItemsTable({
  items,
  onResend,
  onRevoke,
  onlyGroups,
  userOwner,
  disabled,
  readonly
}: {
  items: SelectorItem[]
  onResend?: (item: SelectorItem, action?: 'resend' | 'revoke') => void
  onRevoke: (item: SelectorItem, action?: 'resend' | 'revoke') => void
  onlyGroups?: boolean
  userOwner?: Users | null
  disabled?: boolean
  readonly?: boolean
}) {
  return (
    <TableContainer>
      <Table aria-label="shared table">
        <TableBody>
          {items.map((row: SelectorItem) => (
            <SharedWithItemsRow
              key={row.id}
              item={row}
              onResend={onResend}
              onRevoke={onRevoke}
              hideRole={onlyGroups}
              hideActions={disabled}
              disabled={readonly}
            />
          ))}
          {!onlyGroups && userOwner && <OwnerRow owner={userOwner} hideActions={disabled} />}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SharedWithItemsTable
